import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import EditIcon from '../../Icons/EditIcon';

export function ModalInput({
  component,
  header,
  showFooter,
  showModal,
  setShowModal,
  intl,
}) {
  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);  
  return (
    <>
      <Button
        variant="primary"
        onClick={handleShow}
        className="photo-uploader__image-list-Modal-edit-button"
      >
        <EditIcon fill="white" /> <FormattedMessage id="metaInput.editField" />
      </Button>

      <Modal
        show={showModal}
        onHide={handleClose}
        dialogClassName="photo-uploader__image-list-Modal-dialog"
      >
        <Modal.Header>
          <Modal.Title>{header}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="photo-uploader__image-list-Modal-content">
          {component}
        </Modal.Body>
        {showFooter && (
          <Modal.Footer>
            <Button variant="primary" onClick={handleClose}>
              <FormattedMessage id="general.save" />
            </Button>
          </Modal.Footer>
        )}
      </Modal>
    </>
  );
};
